import { render, staticRenderFns } from "./InsertEditComponent.vue?vue&type=template&id=21ac5910&scoped=true&"
import script from "./InsertEditComponent.vue?vue&type=script&lang=js&"
export * from "./InsertEditComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ac5910",
  null
  
)

export default component.exports